export const translationsEnUS = {
  "generic.language.english": "English",
  "generic.language.french": "French",
  "generic.connect.google": "Connect with Google",
  "generic.button.title.save": "Save",
  "generic.crud.create.cta": "Create",
  "generic.use.none": "None",
  "generic.use.next": "Next",
  "generic.dataType.string": "character strings",
  "generic.dataType.string.developped":
    "various words and texts, URL and others",
  "generic.dataType.boolean": "true / false",
  "generic.dataType.boolean.developped":
    "a value that can only be true or false, like yes or no",
  "generic.dataType.number": "figures and numbers",
  "generic.dataType.number.developped":
    "any kind of number. Can not contain any word.",
  "generic.dataType.date": "dates",
  "generic.dataType.date.developped":
    "any kind of dates, containing at least the year",
  "generic.dataType.enum": "defined list",
  "generic.dataType.enum.developped":
    "list that contains only limited and known values",
  "generic.form.dropdown.placeholder": "Select ...",
  "generic.save": "Save",
  "generic.notification.error": "There has been an error. Please try later.",
  "generic.notification.error.showMessage":
    "There has been an error while doing the operation. Error :",
  "generic.contactUs.calendly": "Book a call",

  "site.global.tabTitle":
    "Chatsystem.ai | Sales Agent for your ecommerce products",
  "site.global.description": "Please your customers with the best AI advice",

  "pagination.previous": "previous",
  "pagination.next": "next",

  "textarea.placeholder.nonBoolean.semanticDescription":
    "Ex: The size of the clothe",
  "textarea.placeholder.boolean.semanticDescription":
    "Ex: Is that meal gluten free?",
  "textarea.errorMessage.minLength0":
    "This sentence is very important to help the robot analyze what the customer is asking.",
  "textarea.errorMessage.shouldEndWithQuestionMark":
    "In case of true/false column, your description must be a question. Example: Is this dish vegetarian? The sentence must finish with a question mark.",
  "input.placeholder.columnName": "Ex: Type of Boardgames",
  "input.errorMessage.minLength0":
    "This field is mandatory for the robot to understand what is the data about. Give a name a friend would understand.",

  "page.login.button.login": "Login / Register",
  "page.login.google.login": "Continue with Google",

  "navbar.button.home": "Home",
  "navbar.button.pricing": "Pricing",
  "navbar.button.login": "Login",
  "navbar.button.demo": "Demo",
  "navbar.userMenu.logout": "Log out",
  "navbar.userMenu.profile": "Profile",
  "navbar.userMenu.admin": "Admin",
  "navbar.userMenu.backOffice": "Back-office",

  "home.header.catchphase": "Finally a smart chatbot",
  "home.header.subcatchphase":
    "Discover the chatbot that knows your products inside out",
  "home.header.CTA": "See more",
  "home.section.bulletsPointParagraphe1.title": "Relevant",
  "home.section.bulletsPointParagraphe1.text":
    "Makes the best product recommendations based on your inventory and customer demand",
  "home.section.bulletsPointParagraphe2.title": "Listening",
  "home.section.bulletsPointParagraphe2.text":
    "Really understands your customers and their purchase intent before responding to them",
  "home.section.bulletsPointParagraphe3.title": "Flexible",
  "home.section.bulletsPointParagraphe3.text":
    "Adjusts to customer requests to always provide an appropriate response",

  "home.realm.title": "The next generation of artificial intelligence",
  "home.realm.text":
    "New AI technologies enable a revolution in the behavior of automated agents. Our chatbot is built on this strong pillar that opens up new usage perspectives for customers",
  "home.realm.cta": "Discover our solution",
  "home.realm.secondary.title": "See the root of your business in a few clicks",
  "home.realm.secondary.text":
    "The security of your data is at the heart of our concerns. Our software was created in France, we are ISO 27001 certified and all our servers are located in Europe.",
  "home.realm.secondary.cta": "Discover our solution",
  "home.testimonials.title": "What our customers say",
  "home.testimonials.1.text":
    "Since using the software, we have better control of the flow of goods and relevant performance monitoring.",
  "home.testimonials.1.job": "Developer @Wordpress",
  "home.testimonials.1.name": "Loic Martins",
  "home.testimonials.2.text":
    "Putting the software solution into production allowed us to completely reorganize the teams.",
  "home.testimonials.2.job": "Community Manager @Comet",
  "home.testimonials.2.name": "Anna Wang",
  "home.testimonials.3.text":
    "Mastery of the logistics subject is obvious with the software solution.",
  "home.testimonials.3.job": "Product Owner @April",
  "home.testimonials.3.name": "Louis Bachant",
  "home.test.section.title": "Try it out now",
  "home.book.section.title": "See it now",
  "home.test.section.CTA": "See our solution",

  "article.doesntExist":
    "This article does not exist. Please head back to the homepage.",

  "pricing.CTA.pleaseLogin": "Login to buy",
  "pricing.page.title": "Choose your plan",
  "pricing.page.subtitle": "No obligation: cancel at any time with one click.",
  "pricing.page.plan.highlight": "MOST POPULAR",
  "pricing.page.buttonText.buy": "Buy",
  "pricing.page.buttonText.YouAlreadyHaveIt": "Your current formula",
  "pricing.page.formula.feature.alreadySubbed": "Already Subscribed",
  "pricing.page.formulaName.fixedIncreasable": "Fixed renewable",
  "pricing.page.formulaName.fixedPlusDynamic": "Fixed + Variable",
  "pricing.page.formulaName.fullDynamic": "Fully variable",
  "pricing.page.formulaName.fullFixed": "Fixed capped",
  "pricing.page.formulaName.custom": "Custom",
  "pricing.page.buttonText.contactUs": "Contact us",
  "pricing.page.formula.feature.botAccess": "Chatbot Access",
  "pricing.page.formula.feature.limitedAccess": "Limited Access",
  "pricing.page.formula.feature.unlimitedAccess": "Illimited Access",
  "pricing.page.formula.feature.userFollowUp": "User Discussion Follow-up",
  "pricing.page.formula.feature.useAtscale": "Use at scale",

  "subscribe.paymentRecap.title": "Payment Summary",
  "subscribe.paymentRecap.customerName": "Name",
  "subscribe.paymentRecap.customerMail": "Email",
  "subscribe.paymentRecap.additionnalMention": "Mention to add",
  "subscribe.paymentRecap.totalAmount": "Total Amount",
  "subscribe.paymentForm.title": "Bank card",
  "subscribe.paymentForm.cardNumber": "Card number",
  "subscribe.paymentForm.expiresAt": "Expires at",
  "subscribe.paymentForm.CVCNumber": "CVC number",
  "subscribe.paymentForm.CTA.loading": "Loading ...",
  "subscribe.paymentForm.CTA.pay": "Pay now",

  "subscribe.success.title": "Payment successful",
  "subscribe.success.paragraph1":
    "Your payment has been processed successfully. You are now suscribed !",
  "subscribe.success.paragraph2": "Your new options are now available.",

  "myAccount.page.leftMenu.general": "General",
  "myAccount.page.leftMenu.profile": "Profile",
  "myAccount.page.leftMenu.setup": "Setup",
  "myAccount.page.leftMenu.upload": "Upload Products",
  "myAccount.page.leftMenu.myCatalogs": "My Catalogs",
  "myAccount.page.leftMenu.myAgents": "My Agents",
  "myAccount.page.leftMenu.myDNS": "My authorized domain names",
  "myAccount.page.leftMenu.sessions": "User Discussions",
  "myAccount.page.leftMenu.testMyChatbot": "Test my Chatbot",
  "myAccount.page.leftMenu.settings": "Settings",
  "myAccount.page.leftMenu.devSpace": "Developper Area",
  "myAccount.page.setup.title": "Setup",
  "myAccount.page.setup.client": "Client side",
  "myAccount.page.setup.api": "Api side",
  "myAccount.page.setup.jwt.description": "Your JWT for API use:",
  "myAccount.page.setup.jwt.copyClipboard": "JWT copied !",
  "myAccount.page.sesstions.title": "User Discussions",
  "myAccount.page.subscriptionFormulas.title": "Subscription Formulas",
  "myAccount.page.setup.subscribe":
    "Subscribe to get your access token and be able to use the app.",
  "myAccount.page.setup.appTokenIs": "Your appToken is",
  "myAccount.page.setup.copySnippetWidget":
    "Copy this into your html page to make it work",
  "myAccount.page.setup.copySnippetReact":
    "Import the react app at the root of your tree with the props appToken",

  "myAccount.page.setup.documentation.title": "Documentation",
  "myAccount.page.setup.documentation.documentationExplaination":
    "Documentation is available on that ",
  "myAccount.page.setup.documentation.documentationExplaination.link": "link",
  "myAccount.page.setup.documentation.swaggerExplaination":
    "Swagger is available on that ",
  "myAccount.page.setup.documentation.swaggerExplaination.link": "link",

  "myAccount.page.upload.title": "Upload your products",
  "myAccount.page.upload.uploadFile.explaination":
    "Please choose a CSV or XLSX file containing your products.",
  "myAccount.page.upload.catalogSelection.dropdown.explaination":
    "Choose a catalog to upload your products to. You can create a catalog from a file, or upload products on an existing catalog.",
  "myAccount.page.upload.catalogSelection.dropdown.placeholder":
    "Choose a catalog",
  "myAccount.page.upload.catalogSelection.dropdown.addNew":
    "Create a new catalog",

  "myAccount.page.upload.uploadFile.noFile": "No files have been uploaded.",

  "myAccount.page.upload.MandatoryColumns.title":
    "Mandatory Columns for the agent",
  "myAccount.page.upload.MandatoryColumns.explaination":
    "In order to properly construct customer response messages, we need to know specifically the following columns in your file. These columns are mandatory so that the robot's return is at the expected quality level.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.description":
    "Description",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.description.details":
    "Specify the column containing the product description. The more detailed the description, the better the search will be.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.doesNotExist":
    "Does not exist in this file",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.fr":
    "Product Name FR",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.fr.details":
    "Indicate the column containing the FRENCH name of your product. This is the name that will be displayed in the chat when your product is recommended by the robot. Only one language is mandatory for product names.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.en":
    "Product Name EN",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.en.details":
    "Indicate the column containing the ENGLISH name of your product. This is the name that will be displayed in the chat when your product is recommended by the robot. Only one language is mandatory for product names.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.sellingPrice":
    "Selling Price",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.sellingPrice.details":
    "Indicate the column containing the price of the product. This is the price that will be indicated in the chat when the product is recommended.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.urlProduct":
    "URL Product",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.urlProduct.details":
    "Indicate the column containing the URL of the product sheet. This is the URL that will be used to redirect the user when they click on the product in the chat.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.imageSrc":
    "URL Product Image",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.imageSrc.details":
    "Specify the column containing the product image URL. This image will be displayed in the chat result.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.customerProductId":
    "Product ID",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.customerProductId.details":
    "Specify the column containing the product ID. Each ID should be unique for each product.",
  "myAccount.page.upload.MandatoryColumns.validation.cta": "Ok",

  "myAccount.page.upload.columnSearchSelection.introduction":
    "Which columns do you want to use to filter products for your customers ? Choose the ones that make sense, that define your product, on which a search can be made.",
  "myAccount.page.upload.columnSearchSelection.title": "Select useful columns",

  "myAccount.page.upload.mandatoryColumns.title": "Select mandatory columns",
  "myAccount.page.upload.mandatoryColumns.explanaition":
    "Among the search criteria, is a criteria mandatory? To offer products to your customers? For example, to advise a board game to a customer, age is very important: for a child we do not recommend the same game as for an adult.",
  "myAccount.page.upload.mandatoryColumns.explanaition.two":
    "If you check a box here, the robot will request this information from the customer.",
  "myAccount.page.upload.mandatoryColumns.maximumSelection":
    "Please choose 3 mandatory categories maximum.",

  "myAccount.page.upload.columnDefinition.title":
    "Explain your data to the robot",
  "myAccount.page.upload.columnDefinition.explaination.danger":
    "The robot needs to understand what data it is browsing. This step is very important for understanding the products in your catalog.",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.name":
    "Give easy-to-understand names",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.dataType":
    "Specify the type of data so that the robot knows how to browse it",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.semanticDescription":
    "Explain each data in one sentence",
  "myAccount.page.upload.columnDefinition.explaination.recap.understanding":
    "It is very important that the robot understands what data it is consulting when it searches for a product. Are they numbers, dates, a set of words, or true/false columns?",
  "myAccount.page.upload.columnDefinition.explaination.recap.qualityMatters":
    "Depending on the quality of the information entered, the robot will be more or less efficient in providing product advice.",
  "myAccount.page.upload.columnDefinition.explaination.recap.checkColumns":
    "Let's check each column together.",
  "myAccount.page.upload.columnDefinition.form.invalid":
    "Some columns have not been completely filled out. Look for the red fields!",

  "myAccount.page.upload.columnDefinitionSetter.mandatory": "Mandatory",
  "myAccount.page.upload.columnDefinitionSetter.mandatoryExplaination":
    "This column is mandatory and cannot be modified",
  "myAccount.page.upload.columnDefinitionSetter.emptyLine": "Empty line",

  "myAccount.page.upload.columnDefinition.column": "Defining Column",
  "myAccount.page.upload.columnDefinition.name": "Name for the robot",
  "myAccount.page.upload.columnDefinition.type": "Type",
  "myAccount.page.upload.columnDefinition.semanticDescription": "Explaination",

  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.ProductName":
    "Product Name",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.ProductName":
    "The name of the product",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.Price":
    "Product Price",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.Price":
    "The price of the product",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.Description":
    "Product Description",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.Description":
    "The description of the product",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.URLProduct":
    "URL Product",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.URLProduct":
    "The URL that links to the product",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.ImageURL":
    "Url Product Image",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.ImageURL":
    "The URL that links to the product image",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.customerProductId":
    "Product ID",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.customerProductId":
    "The unique identifier of the product",

  "myAccount.page.upload.columnDefinition.type.chosenType":
    "Current type entered:",
  "myAccount.page.upload.columnDefinition.type.dataSample":
    "Example data for this column from your data:",
  "myAccount.page.upload.columnDefinition.type.editType": "Change column type:",

  "myAccount.page.upload.columnDefinition.columnNameHelper.header":
    "More information about the name",
  "myAccount.page.upload.columnDefinition.columnNameHelper.intro":
    "Indicate an easy-to-understand name for the robot.",
  "myAccount.page.upload.columnDefinition.columnNameHelper.explicationOne":
    "The simple, explanatory name is important because it helps the robot understand what data we are talking about.",
  "myAccount.page.upload.columnDefinition.columnNameHelper.explicationTwo":
    "Examples: 'board games', 'number of players' are simple nouns. 'UK_896' is not a simple name.",

  "myAccount.page.upload.columnDefinition.columnTypeHelper.header":
    "More information about the type",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.explaination":
    "Specifying the column type is very important because it allows the robot to know how to search.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.intro":
    "Here are the different possible types:",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.enum.title":
    "Defined list",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.enum.content":
    "A defined list is a list of which we know all the values in advance. For example, clothing sizes: S, XS, M, L, XL, XXL. Or tags for products - for example, 'Science Fiction', 'Western', 'Romance' for books. It’s a fixed list, of which we know all the options.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.text.title": "Text",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.text.content":
    "This is the broadest section. For all unstructured texts, such as a description, classic information.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.number.title":
    "Figures and numbers",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.number.content":
    "If the data is a number or a digit. There can't be a letter. '91' is a number, '91z' is text.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.date.title": "Date",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.date.content":
    "If the data is a date.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.boolean.title":
    "True/False",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.boolean.content":
    "If the data is of type yes/no, or true/false. For example, is a dish gluten-free.",

  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.header":
    "More information on description",

  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionOne":
    "Explain in one sentence what this column contains, in a simple way that a friend would understand.",
  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionTwo":
    "Example: a column with a name 'game duration' could contain the following sentence: 'The game duration desired by the customer'",
  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionThree":
    "True/false columns must be a question. Example: 'Is this dish gluten-free?'",

  "myAccount.page.upload.columnDefinition.name.mandatory.isMappedTo":
    "Is tagged as mandatory field ",

  "columnDefinition.checkbox.isRequired":
    "This data is required for the AI assistant",
  "columnDefinition.cta.addProperty": "Add a property",

  "myAccount.page.upload.productDefinition.title":
    "Catalog Products Definition",
  "myAccount.page.upload.productDefinition.intro":
    "This is for the robot to understand your data. Please indicate a short name that summarize the type of article that you will reference in the robot. This description will once again help him to be a good seller in the category you are going to indicate.",
  "myAccount.page.upload.productDefinition.placeholder":
    "Indicate the category of your products. Example : Smartphones",
  "myAccount.page.upload.catalog.title": "Catalog Name",
  "myAccount.page.upload.catalog.intro":
    "Give a name to your catalog. This name if for your internal use only",
  "myAccount.page.upload.catalog.placeholder": "Smartphones",

  "myAccount.page.upload.processing.singleValueError.boolean":
    "Boolean value non recognized",
  "myAccount.page.upload.processing.singleValueError.number":
    "Number value non recognized",
  "myAccount.page.upload.processing.singleValueError.date":
    "Date value non recognized",
  "myAccount.page.upload.processing.singleValueError.text":
    "Text value non recognized",
  "myAccount.page.upload.processing.singleValueError.enum":
    "Enum value non recognized",
  "myAccount.page.upload.processing.singleValueError.url":
    "Url value non recognized. It should start with 'http'.",
  "myAccount.page.upload.processing.lineError":
    "Line: {indexProduct} - Error while parsing: Property: {property} / Value received: {value}",
  "myAccount.page.upload.processing.notHandledError":
    "Line: {indexProduct} - Data not handled: Property: {property} / Value received: {value}",

  "myAccount.page.upload.error.intro": "There are errors processing your file.",
  "myAccount.page.upload.error.explaination":
    "Each line with an error is shown below. Please check the corresponding content and correct it. You may then upload it again (your settings are not lost)",
  "myAccount.page.upload.button.cta": "Upload",
  "myAccount.page.upload.success.notification":
    "Your file has been successfully uploaded.",
  "myAccount.page.upload.failure.notification":
    "Your file could not be uploaded. Please fix the errors displayed, either in the file or in the column definitions, and upload again.",
  "myAccount.page.upload.failure.restartUpload": "Recommencer",

  "myAccount.page.upload.success.component.title": "Success",
  "myAccount.page.upload.success.component.explaination":
    "Your file have been successfully uploaded.",
  "myAccount.page.upload.success.component.explaination2":
    "Products will now be displayed in the chatbot results to your customers.",

  "myAccount.page.myCatalogs.catalog.title": "Catalog",
  "myAccount.page.myCatalogs.catalog.name": "Name",
  "myAccount.page.myCatalogs.catalog.isDefault": "Is Default",
  "myAccount.page.myCatalogs.catalog.default": "Default",
  "myAccount.page.myCatalogs.catalog.productDefinition":
    "Product Catalog Definition",
  "myAccount.page.myCatalogs.catalog.delete": "Delete the catalog",
  "myAccount.page.myCatalogs.catalog.delete.success":
    "The catalog has been deleted.",
  "myAccount.page.myCatalogs.catalog.products.delete.cta":
    "Delete Products of the catalog.",
  "myAccount.page.myCatalogs.catalog.products.delete.success":
    "The products of the catalog has been deleted.",
  "myAccount.page.myCatalogs.catalog.numberOfProducts": "Number of products:",
  "myAccount.page.myCatalogs.all.noCatalogs":
    "You don't have any catalogs for now",
  "myAccount.page.myCatalogs.cta.create": "Create a catalog",
  "myAccount.page.myCatalogs.cta.save": "Save catalog",
  "myAccount.page.myCatalogs.save.success":
    "Your catalog has been successfully created.",
  "myAccount.page.myCatalogs.save.error":
    "There has been an error creating your catalog. Please contact support.",
  "myAccount.page.myCatalogs.creation.success.title": "Success",
  "myAccount.page.myCatalogs.creation.success.explaination":
    "Your catalog has been successfully created.",
  "myAccount.page.myCatalogs.creation.success.explaination2":
    "You can now use it to upload products onto your chatbot agent.",
  "myAccount.page.myCatalogs.edition.save.cta": "Save modifications",
  "myAccount.page.myCatalogs.edition.searchFilter.edit.cta":
    "Edit Search Filter",
  "myAccount.page.myCatalogs.edition.searchFilter.save.cta":
    "Save Search Filters",
  "myAccount.page.myCatalogs.edition.save.success":
    "Your catalog has been successfully edited.",
  "myAccount.page.myCatalogs.searchFiltersedition.title": "Edit Search Filters",
  "myAccount.page.myCatalogs.searchFiltersedition.save.success":
    "Your search filters have been successfully edited.",
  "myAccount.page.myCatalogs.searchFiltersedition.edit.notIfProductsExist":
    "You cannot edit Search Filters from a Catalog with existing products. Empty all products of the Catalog before changing it.",

  "myAccount.page.myAgents.cta.save": "Save Agent",
  "myAccount.page.myAgents.cta.title": "Edit Agent",
  "myAccount.page.myAgents.cta.field.name": "Name",
  "myAccount.page.myAgents.cta.field.startingText": "Chatbot Starting Text",

  "myAccount.page.myDNS.intro":
    "Manage all authorized domain names for your agent here",
  "myAccount.page.myDNS.CTA.addNewDNS": "Add a new domain",
  "myAccount.page.myDNS.CTA.save": "Save",
  "myAccount.page.myDNS.save.success":
    "Authorized domain names have been successfully updated",
  "myAccount.page.myDNS.save.failure":
    "Domain names could not be updated. Please contact support.",

  "myAccount.page.profile.title": "My profile",
  "myAccount.page.profile.company.name.title": "Company Name",
  "myAccount.page.profile.company.name.monthlyMaxBudget":
    "Monthly Max Budget (Leave empty to not set one)",
  "myAccount.page.profile.company.placeholder": "Add your company name",
  "myAccount.page.profile.company.save.success":
    "Your company has been successfully updated.",
  "myAccount.page.company.save.failure":
    "Your company could not be updated. Please contact support.",
  "myAccount.page.profile.company.cannotEditMaxBudget":
    "Since your formula has a fixed spending threshold, you cannot modify this field.",

  "myAccount.page.myUserSessions.all.table.title": "User Discussions",
  "myAccount.page.myUserSessions.all.table.id": "Id",
  "myAccount.page.myUserSessions.all.table.agent": "Agent",
  "myAccount.page.myUserSessions.all.table.numberOfMessages":
    "Number of messages",
  "myAccount.page.myUserSessions.all.table.Totalduration": "Total Duration",
  "myAccount.page.myUserSessions.all.table.TFTduration": "TFT Duration",
  "myAccount.page.myUserSessions.all.table.COT": "COT",
  "myAccount.page.myUserSessions.all.table.LastUse": "Creation",
  "myAccount.page.myUserSessions.all.noUserSession":
    "You don't have any user discussion for now.",

  "admin.page.companies.all.table.title": "Companies",
  "admin.page.companies.all.table.id": "Id",
  "admin.page.companies.all.table.name": "Name",
  "admin.page.companies.all.table.mail": "Mail",
  "admin.page.companies.all.noCompanies":
    "There are not any companies for now.",
  "admin.page.companies.crud.edit.title": "Update a company",
  "admin.page.companies.crud.edit.agentsDisplayed.title": "Company Agents",
  "admin.page.companies.crud.create": "Create a company",
  "admin.page.companies.crud.create.success":
    "The company has been created successfully.",
  "admin.page.companies.crud.update.success":
    "The company has been updated successfully.",

  "admin.page.agents.all.table.title": "Agents",
  "admin.page.agents.all.table.id": "Id",
  "admin.page.agents.all.table.name": "Name",
  "admin.page.agents.all.table.isDefault": "is Default",
  "admin.page.agents.all.table.commpanyId": "CompanyId",
  "admin.page.agents.all.noAgents": "There are not any agents for now.",
  "admin.page.agents.crud.edit.title": "Update a Agent",
  "admin.page.agents.crud.update.success":
    "The agent has been updated successfully.",

  "admin.page.catalogs.all.table.title": "Catalogs",
  "admin.page.catalogs.all.table.id": "Id",
  "admin.page.catalogs.all.table.name": "Name",
  "admin.page.catalogs.all.nocatalogs": "There are not any catalogs for now.",
  "admin.page.companies.crud.edit.catalogDisplayed.title": "Agent Catalogs",
  "admin.page.catalogs.crud.edit.title": "Update a Catalog",
  "admin.page.catalogs.crud.update.success":
    "The catalog has been updated successfully.",

  "admin.page.users.all.table.title": "Users",
  "admin.page.users.all.table.id": "Id",
  "admin.page.users.all.table.name": "Name",
  "admin.page.users.all.table.mail": "Mail",
  "admin.page.users.all.noUsers": "There are not any users for now.",
  "admin.page.users.crud.edit.title": "Update an user",
  "admin.page.users.crud.update.success":
    "The user has been updated successfully.",

  "myAccount.page.oneSession.title": "User Discussion",

  "myAccount.page.myChatbot.errorBlockingAgentDisplay":
    "Some errors prevent the chatbot to display.",
  "myAccount.page.myChatbot.noSearchFilter.title": "No Search Filters",
  "myAccount.page.myChatbot.noSearchFilter":
    "You have no search filters setup for your chatbot. It means it cannot use criterias to search. Please set them up.",
  "myAccount.page.myChatbot.noProducts.title": "No products",
  "myAccount.page.myChatbot.noProducts":
    "You have no products setup for your chatbot. It means it cannot find anything. Please upload them.",
  "myAccount.page.myChatbot.noCatalogs.title": "No Catalog",
  "myAccount.page.myChatbot.noCatalogs":
    "You have no products catalogs for your chatbot. It means it cannot find or search anything. Please create them.",

  "admin.page.leftMenu.entity": "Entities",
  "admin.page.leftMenu.workflow": "Workflow",
  "admin.page.leftMenu.entities.companies": "Companies",
  "admin.page.leftMenu.entities.agents": "Agents",
  "admin.page.leftMenu.entities.catalogs": "Catalogs",
  "admin.page.leftMenu.entities.users": "Users",
  "admin.page.leftMenu.workflow.onboard": "Manual Onboard",

  "admin.session.cost": "Cost (cents)",
  "admin.session.oneSession.cost": "Cost (cents)",
  "admin.session.oneSession.message.functionUsed": "Function:",
  "admin.session.oneSession.message.model": "Model",
  "admin.session.oneSession.message.provider": "Provider",
  "admin.session.oneSession.message.duration": "Duration",
  "admin.session.oneSession.message.cost": "Cost (cents)",
  "admin.subscriptionFormula.add": "Add",
  "admin.subscriptionFormula.id": "Id",
  "admin.subscriptionFormula.fixedPrice": "Base Price",
  "admin.subscriptionFormula.BSPriceResell": "User Discussion Price",
  "admin.subscriptionFormula.isDisplayedOnFrontEnd": "Is Front-end",
  "admin.subscriptionFormula.subscriptionType": "Subscription Type",
  "admin.subscriptionFormula.noOne":
    "There are no susbcription formulas at the moment.",
  "admin.subscriptionFormula.page.create.title":
    "Create a new Subscription Formula",

  "chatbot.placeholder.content": "Message the assistant...",
  "chatbot.chatline.label.user": "You",
  "chatbot.chatline.label.assistant": "Assistant",
  "chatbot.chatline.loading.function.genericSearchMessage":
    "I'm looking for products",
  "chatbot.chatline.loading.function.search": "Search",
  "chatbot.chatline.loading.function.extractProductName":
    "Looking into the cavern",
  "chatbot.chatline.loading.function.suggestProductName":
    "Consulting the shadocks",
  "chatbot.chatline.loading.function.criteriaDefinition":
    "Looking for ziboublis",
  "chatbot.chatline.loading.function.searchStock": "Searching Stock",
  "chatbot.chatline.loading.function.step": "Step",

  "footer.tab.title.general": "General",
  "footer.tab.title.about": "About",
  "footer.tab.title.resources": "Resources",
  "footer.tab.title.legal": "Legal",
  "footer.tab.title.social": "Social",
  "footer.tab.title.articles": "Articles",
  "footer.tab.title.chatbot": "Chatbot",
  "footer.tab.title.data_augmentation": "Data Augmentation",
  "footer.tab.search": "Search",
  "footer.tab.pricing": "Pricing",
  "footer.tab.termsAndConditions": "Terms and conditions",
  "footer.tab.documentation": "Documentation",
  "footer.tab.finalCopyright":
    "Copyright © 2025 Logiciel, Inc. All rights reserved.",
};
